(function(){
  var declinePattern = /(decline|deny|reject|avvisa|neka|avslå|avsla|avvisa alla|neka alla|reject all)/i;
  var preferencePattern = /(preference|preferences|preferenser|inställningar|installningar|customize|anpassa)/i;
  var bannerSelectors = [
    '#shopify-pc__banner',
    '#shopify-pc__banner__dialog',
    '.shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '[id^="shopify-pc__banner"]',
    '[class*="shopify-pc__banner"]'
  ];
  var preferenceSelectors = [
    '#shopify-pc__prefs',
    '#shopify-pc__prefs__dialog',
    '#shopify-pc__preferences',
    '[id^="shopify-pc__prefs"]',
    '[class*="shopify-pc__prefs"]',
    '[id*="preferences-dialog"]',
    '[class*="preferences-dialog"]'
  ];

  function getText(el){
    return String((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el){
    if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
    return !style || (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0');
  }

  function findBanner(){
    for (var i = 0; i < bannerSelectors.length; i++) {
      var el = document.querySelector(bannerSelectors[i]);
      if (isVisible(el)) return el;
    }

    return null;
  }

  function hasOpenPreferences(){
    for (var i = 0; i < preferenceSelectors.length; i++) {
      var el = document.querySelector(preferenceSelectors[i]);
      if (isVisible(el)) return true;
    }

    return false;
  }

  function isInitialBanner(el){
    if (!el) return false;

    var text = getText(el);
    return preferencePattern.test(text);
  }

  function syncInitialDeclineButton(){
    var banner = findBanner();
    if (!banner) return;

    var buttons = banner.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]');
    var shouldHideInitialDecline = isInitialBanner(banner) && !hasOpenPreferences();

    buttons.forEach(function(button){
      var text = getText(button) || String(button.value || '').trim() || String(button.getAttribute('aria-label') || '').trim();
      var shouldHide = shouldHideInitialDecline && declinePattern.test(text) && !preferencePattern.test(text);

      if (shouldHide) {
        button.classList.add('wubs-privacy-hide-initial-decline');
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');
      } else {
        button.classList.remove('wubs-privacy-hide-initial-decline');
        button.removeAttribute('aria-hidden');
        button.removeAttribute('tabindex');
      }
    });
  }

  function scheduleSync(){
    window.requestAnimationFrame(syncInitialDeclineButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  var observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:['class', 'style', 'hidden', 'aria-hidden']
  });
})();
